// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

// Package modules.
import styled from '@emotion/styled';
import { Link as BaseLink } from 'react-navi';

// Exports.
export const Link = styled(BaseLink)`
  color: ${({ theme }) => theme.palette.volare};
  text-decoration: underline;

  &:hover {
    color: ${({ theme }) => theme.palette.antigua};
  }

  transition: color 250ms ease-in;
`;
